/**
 * TanStack Query hooks for `saved-report-templates`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	savedReportTemplatesQueryKeys,
	type CreateSavedReportTemplateBody,
	type ListSavedReportTemplatesResponse,
	type SavedReportTemplateRow,
} from "./api";

export function useSavedReportTemplatesList(): UseQueryResult<
	ListSavedReportTemplatesResponse,
	Error
> {
	return useQuery({
		queryKey: savedReportTemplatesQueryKeys.list(),
		queryFn: list,
	});
}

export function useSavedReportTemplatesCreate(): UseMutationResult<
	SavedReportTemplateRow,
	Error,
	CreateSavedReportTemplateBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: savedReportTemplatesQueryKeys.all });
		},
	});
}

export function useSavedReportTemplatesDelete(): UseMutationResult<
	{ removed: boolean },
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: savedReportTemplatesQueryKeys.all });
		},
	});
}
